import {t} from "@lingui/core/macro";
import {useContext} from "react";
// eslint-disable-next-line no-restricted-imports -- porting form old code.
import {Prompt} from "react-router";
import {
    UNSAFE_DataRouterContext,
    unstable_usePrompt as usePrompt,
} from "react-router-dom-v5-compat";

const RRv6Prompt = () => {
    usePrompt({
        when: true,
        message: t`Your progress will be lost if you do not submit your assignment. Are you sure you want to leave?`,
    });
    return null;
};
export const AssignmentsNavigatePrompt = () => {
    // unstable_usePrompt is only available if we're inside of a RRv6 data router.
    // If we're not then we fallback to the RRv5 Prompt component.
    const context = useContext(UNSAFE_DataRouterContext);

    if (context) {
        return <RRv6Prompt />;
    }

    return (
        <Prompt
            when={true}
            message={t`Your progress will be lost if you do not submit your assignment. Are you sure you want to leave?`}
        />
    );
};
